import MessagesWidget from "views/logic/widgets/MessagesWidget";
import { updateWidgetConfig } from "views/logic/slices/widgetActions";
const RemoveFromTableActionHandler = ({ field, contexts: { widget } }) => (dispatch) => {
  const newFields = widget.config.fields.filter((f) => f !== field);
  const newConfig = widget.config.toBuilder().fields(newFields).build();
  return dispatch(updateWidgetConfig(widget.id, newConfig));
};
const isEnabled = ({
  contexts: { widget },
  field
}) => {
  if (MessagesWidget.isMessagesWidget(widget) && widget.config) {
    const fields = widget.config.fields || [];
    return fields.includes(field);
  }
  return false;
};
const isHidden = ({
  contexts: { widget }
}) => !widget;
RemoveFromTableActionHandler.isEnabled = isEnabled;
RemoveFromTableActionHandler.isHidden = isHidden;
export default RemoveFromTableActionHandler;
